<template>
  <div v-if="bodyShow" class="main">
    <template v-if="showPage==1" >
        <div class="bg-one">
            <div class="p-box animated fadeInRight">
                <img class="title" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/title.png" alt="">
                <img class="line" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/line.png" alt="">
                <div class="bg2">
                    <!-- :style="{overflowY:text_top==0?'auto':'hidden'}" -->
                    <div  class="text"  ref="main"  >
                        <!--:style="{marginTop:text_top+'px'}"  -->
                        <div class="mt_2" v-if="mainshow" id="main"></div>
                        <div  id="print" >
                            <p>这世界上只有1%的人相信就算很难，不酷，无人⿎掌也要</p>
                            <p class="on">坚持创造⾃⼰想要的生活</p>
                            <!-- <p>这世界上只有1%的人相信就算很难，不酷，无人⿎掌也要坚持创造⾃⼰想要的生活</p> -->
                            <p>这1%的人</p>
                            <p>会在每年1⽉1⽇</p>
                            <p>收到⼀个神秘节⽇的邀请</p>
                            <p>成为「 做自己」的代言人</p>
                            <p class="on">和你⼀样</p>
                            <p>你们这1%的人</p>
                            <p>很相像但又各有特点</p>
                            <p>新⼀届做自己节即将开启</p>
                            <p>来测⼀测，你属于哪⼀种1%？</p>
                            <!-- <p>新⼀届做自己节即将开启来测⼀测，你属于哪⼀种1%？</p> -->
                        </div>
                        <!-- 文字中的“~”，“@” 用来进行控制打印速度-->
                        <!-- <div id="print2" style="display:none;">
                            <p class="on">这世界上只有1%的人相信就算很难，不酷，无人⿎掌也要坚持创造⾃⼰想要的生活@</p>
                            <p>~这1%的人@</p>
                            <p>~会在每年1⽉1⽇@</p>
                            <p>~收到⼀个神秘节⽇的邀请@</p>
                            <p class="on">~成为「 做自己」的代言人和你⼀样@</p>
                            <p>~你们这1%的人@</p>
                            <p>~很相像但又各有特点@</p>
                            <p>~新⼀届做自己节即将开启来测⼀测，你属于哪⼀种1%？@</p>
                        </div> -->
                    </div>
                    <img class="center" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/center.png" alt="">
                </div>
            </div>
        </div>
        <div class="bgf"></div>
        <!-- btn -->
        <a class="btn"  @click="beginAnswer()">
            <img   src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/beginBtn.png" alt="">
        </a>
    </template>
    <div class="bg"  v-if="showPage==2" >
        <!-- 第1题 -->
        <div class="p-box animated fadeInRight">
            <div class="page2">
                <!-- 题目 -->
                <img class="q1" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q1.png" alt="">
                <!-- 答案 -->
                <img @click="clickQustion('one','')"  class="a" v-if="qustion['one'] && qustion['one']=='A'" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q1-a-on.png" alt="">
                <img @click="clickQustion('one','A')" class="a" v-else  src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q1-a.png" alt="">
                <img @click="clickQustion('one','')"  class="b" v-if="qustion['one'] && qustion['one']=='B'" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q1-b-on.png" alt="">
                <img @click="clickQustion('one','B')" class="b" v-else src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q1-b.png" alt="">
                
            </div>
        </div>
    </div>
    <div class="bg"  v-if="showPage==3">
        <!-- 第2题 -->
        <div class="p-box animated fadeInRight">
            <div class="page2">
                <!-- 题目 -->
                <img class="q1" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q2.png" alt="">
                <!-- 答案 -->
                <img @click="clickQustion('two','')"  class="a" v-if="qustion['two'] && qustion['two']=='A'" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q2-a-on.png" alt="">
                <img @click="clickQustion('two','A')" class="a" v-else  src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q2-a.png" alt="">
                <img @click="clickQustion('two','')"  class="b" v-if="qustion['two'] && qustion['two']=='B'" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q2-b-on.png" alt="">
                <img @click="clickQustion('two','B')" class="b" v-else src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q2-b.png" alt="">
                
            </div>
        </div>
    </div>
    <div class="bg"  v-if="showPage==4">
        <!-- 第3题 -->
        <div class="p-box animated fadeInRight">
            <div class="page2">
                <!-- 题目 -->
                <img class="q1" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q3.png" alt="">
                <!-- 答案 -->
                <img @click="clickQustion('three','')"  class="a" v-if="qustion['three'] && qustion['three']=='A'" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q3-a-on.png" alt="">
                <img @click="clickQustion('three','A')" class="a" v-else  src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q3-a.png" alt="">
                <img @click="clickQustion('three','')"  class="b" v-if="qustion['three'] && qustion['three']=='B'" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q3-b-on.png" alt="">
                <img @click="clickQustion('three','B')" class="b" v-else src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q3-b.png" alt="">
                
            </div>
        </div>
    </div>
    <div class="bg" v-if="showPage==5" >
        <!-- 第4题 -->
        <div class="p-box animated fadeInRight">
            <div class="page2">
                <!-- 题目 -->
                <img class="q1" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q4.png" alt="">
                <!-- 答案 -->
                <img @click="clickQustion('four','')"  class="a" v-if="qustion['four'] && qustion['four']=='A'" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q4-a-on.png" alt="">
                <img @click="clickQustion('four','A')" class="a" v-else  src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q4-a.png" alt="">
                <img @click="clickQustion('four','')"  class="b" v-if="qustion['four'] && qustion['four']=='B'" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q4-b-on.png" alt="">
                <img @click="clickQustion('four','B')" class="b" v-else src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q4-b.png" alt="">
                
            </div>
        </div>
    </div>
    <div class="bg"  v-if="showPage==6">
        <!-- 第5题 -->
        <div class="p-box on animated fadeInRight">
            <div class="page5">
                <!-- 题目 -->
                <img class="q5" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q5.png" alt="">
                <!-- 答案 -->
                <div class="option">
                    <img @click="clickQustion('five','')"  class="a" v-if="qustion['five'] && qustion['five']=='A'" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q5-a-on.png" alt="">
                    <img @click="clickQustion('five','A')" class="a" v-else  src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q5-a.png" alt="">
                    <img @click="clickQustion('five','')"  class="b" v-if="qustion['five'] && qustion['five']=='B'" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q5-b-on.png" alt="">
                    <img @click="clickQustion('five','B')" class="b" v-else src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q5-b.png" alt="">
                    <img @click="clickQustion('five','')"  class="c" v-if="qustion['five'] && qustion['five']=='C'" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q5-c-on.png" alt="">
                    <img @click="clickQustion('five','C')" class="c" v-else src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/q5-c.png" alt="">
                </div>
                
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { queryString, getStorage, setStorage, deleteStorage} from '@/utils/tools'
import { getData,saveData,ceping81_support_user,ceping81_info,ceping81_event,ceping_event } from "@/api/measurement";
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            bodyShow:false,
            cid:81,
            // 文字显示
            text_top:176.5,
            print_idx:0,
            // 当前显示的是第几页
            showPage:1,
            // 存储选中得答案
            qustion:{},
            lock:true,
            type_obj:{},
             // 上一页面路由
            formPath: '',
            timer:{},
            mainshow:true
        }
    },
    methods:{
        // 存储答题选项
        clickQustion(idx,val){
            if(this.lock){
                this.lock = false;
                this.$set(this.qustion,idx,val);
                let arr = Object.values(this.qustion);
                setTimeout(()=>{
                    setStorage(this.$route.path,'question',this.qustion);
                    this.lock = true;
                    // 小于五道题并且当前题目答案有值
                    if(this.showPage<=5 && val){
                        this.showPage+=1;
                    }
                    
                },600);
                
                if(arr && arr.length>=5){
                    this.saveDataHandle();
                }
            }
        },
        // 开始答题
        beginAnswer(){

            setStorage(this.$route.path,'print',1);
            this.showPage+=1;
            
        },
        // 打印指定文字
        printTextHanlde(){
            // <!-- 文字中的“~”，“@” 用来进行控制打印速度-->
            let self = this;
            let stime = 100;
            let text = '';
            let setInterval_2 = setInterval(()=>{
                if(document.getElementById("print2") && document.getElementById("print2").innerHTML){
                    text = document.getElementById("print2").innerHTML.substring(0, self.print_idx++);
                    if(document.getElementById("print2").innerHTML.substring(0, self.print_idx)=='@'){
                        stime =10;
                    }   
                    if(document.getElementById("print2").innerHTML.substring(0, self.print_idx)=='~'){
                        stime =100;
                    } 
                    console.log(stime)
                    if(text!='@' && text != '~'){
                        document.getElementById("print").innerHTML = text;
                    }
                    if(document.getElementById("print2").innerHTML.length==document.getElementById("print").innerHTML.length && (text!='@' && text != '~')){
                        clearInterval(setInterval_2);
                    }
                }
            },stime);
        },
        pullData(){
            if(this.$route.query.uid){
                ceping81_support_user({
                    share_uid:this.$route.query.uid
                }).then((data)=>{
                    if(data.code==10002){
                        this.$toast(data.data.msg);
                        return
                    }
                });
            }
            ceping81_info().then((res)=>{
                 this.type_obj = {
                    uid:res.uid
                };
                shareCon("ceping81", this,this.type_obj);
            });
            this.getDataHandle();
        },
        getDataHandle(){
            //调用加载中
            this.$emit('loadingHandle',true,"2024，回来做自己(σ≧∀≦σ)");
            getData({
                cid:this.cid
            }).then((data)=>{
                document.title = '2024，回来做自己(σ≧∀≦σ)';
                //关闭加载中
                this.$emit('loadingHandle',false);
                let seatStorage =  getStorage(this.$route.path,'question');
                this.qustion = data.data?JSON.parse(data.data):{};
                if(Object.keys(this.qustion) && Object.keys(this.qustion).length>=5){
                    if (this.formPath === '/ceping81_poster') {
                        this.$router.back();
                    } else {
                        this.$router.push('/ceping81_poster');
                    }

                }else{
                    this.bodyShow = true;

                    ceping_event({ lead_sid: this.$route.query.lead_sid,
                      cid: this.cid,
                      event: 'ViewIndex',
                    }).then(res=>{
                      // 页面访问统计
                    });
                }
            });
        },
        /*
         *@param: 
         *@return: 
         *@Description:提交操作数据 
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-11-30 11:50:44
        */
        saveDataHandle(){

             // 同步缓存接口
            saveData({
                cid:this.cid,
                data:String(this.qustion)!='{}'&& this.qustion?JSON.stringify(this.qustion):''
            }).then((data)=>{
                // 完成报告统计
                ceping81_event({
                    cid:81,
                    event:'CompleteReport'  
                }).then((data_)=>{
                    this.$router.push('/ceping81_poster');
                });
                    
            });
        }
    },
    mounted(){
        if(this.showPage==1){
            this.$nextTick(()=>{
                let h = 0;
                this.timer = setInterval(()=>{
                    if($('#main').height()>0){
                        if($('#main').height()>20){
                            $('#main').height($('#main').height()-10);
                        }else{
                        
                            let  setIntVal = setInterval(()=>{
                                if(this.$refs.main.scrollHeight){
                                    if(h<(((this.$refs.main.scrollHeight)/2))){
                                        this.$refs.main.scrollTop = (h+=10);
                                    }else{
                                        // this.$refs.main.scrollTop = this.$refs.main.scrollHeight;
                                        setStorage(this.$route.path,'print',1);
                                        // 清理定时器
                                        clearInterval(setIntVal);
                                    }
                                }
                            },150);
                            this.mainshow = false;
                            // 清理定时器
                            clearInterval(this.timer);
                        }
                    }
                },150);
            });
        }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => { //  这里的vm指的就是vue实例，可以用来当做this使用
        vm.formPath = from.path;
      })
    },
    created(){
        this.pullData();
    }
}
</script>
<style lang="scss">
body{
    background-color: #ffffff;
}
</style>
<style lang="scss" scoped>
.main{
    padding: 25px 25px 152px;
    background-color: #FFF4EE;
    overflow: hidden;
    position: relative;
    .bg-one{
        background: url('https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/bg-one.png') no-repeat;
        background-size: cover;
        margin-bottom: 30px;
        .p-box{
            padding: 45px 38px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .title{
            width: 628px;
            height: 128px;
            margin-bottom: 35px;
        }
        .line{
            width: 624px;
            margin-bottom: 30px;
        }
        .bg2{
            width: 626px;
            height: 816px;
            position: relative;
            // margin-bottom: 60px;
            background: url('https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/bg2.png') center no-repeat;
            background-size: cover;
            position: relative;
            .text{
                width: 380px;
                margin: 70px auto 0px;
                height: 353px;
                overflow: auto;
                // transition: all 1s;
                .mt_2{
                    height: 400px;
                }
                p{
                    text-align: center;
                    // font-size: 30px;
                    // color: #B40404;
                    font-size: 28px;
                    color: #666666;
                    // font-weight: 600;
                    line-height: 42px;
                    
                }
                p.on{
                    margin-bottom: 50px;
                    &:last-of-type{
                        margin-bottom: 0px;
                    }
                }
            }
            .center{
                width: 560px;
                height: 30px;
                position: absolute;
                top: 412px;
                left: 34px;
                z-index: 33;
            }
        }
    }
    .bgf{
        background-color: #ffffff;
        height: 168px;
        width: 750px;
        position: absolute;
        left: 0;
        bottom: 0;
    }
    .btn{
        display: block;
        width: 100%;
        max-width: 750px;
        padding: 30px 245px 0px;
        height: 168px;
        // background-color: #ffffff;
        position: fixed;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
        img{
            width: 260px;
        }
    }
    .bg{
        background: url('https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/bg1.png') no-repeat;
        background-size: 100% 100%;
        .p-box{
            padding: 45px 38px 75px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .p-box.on{
            padding: 45px 38px 25px;
        }
        .title{
            width: 628px;
            height: 128px;
            margin-bottom: 35px;
        }
        .line{
            width: 624px;
            margin-bottom: 30px;
        }
        .bg2{
            width: 626px;
            height: 816px;
            position: relative;
            margin-bottom: 60px;
            background: url('https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/bg2.png') center no-repeat;
            background-size: cover;
            position: relative;
            .text{
                width: 370px;
                margin: 70px auto 0px;
                height: 353px;
                overflow: auto;
                // padding-top: 40px;
                // overflow-y: hidden;
                .mt_{
                    margin-top: 353px;
                    transition: all .7s;
                    // height: 808px;
                }
                p{
                    text-align: center;
                    font-size: 30px;
                    color: #B40404;
                    font-weight: 600;
                    line-height: 42px;
                    
                }
                p.on{
                    margin-bottom: 50px;
                    &:last-of-type{
                        margin-bottom: 0px;
                    }
                }
            }
            .center{
                width: 560px;
                height: 30px;
                position: absolute;
                top: 412px;
                left: 34px;
                z-index: 33;
            }
        }
        .btn{
            display: block;
            width: 260px;
            position: fixed;
            left: 50%;
            transform: translateX(-50%);
            img{
                width: 100%;
                height: 100%;
            }
        }
        // 第二页
        .page2{
            display: flex;
            flex-direction: column;
            align-items: center;
            .q1{
                margin-bottom: 68px;
                width: 635px;
            }
            .a{
                margin-bottom: 20px;
                width: 626px;
                cursor: pointer;
            }
            .b{
                width: 626px;
                cursor: pointer;
            }
        }
        // 第五页
        .page5{
            display: flex;
            flex-direction: column;
            align-items: center;
            .q5{
                margin-bottom: 60px;
                width: 635px;
            }
            .option{
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
            }
            .a{
                margin-bottom: 20px;
                width: 300px;
                height: 135px;
                cursor: pointer;
            }
            .b{
                width: 300px;
                height: 135px;
                margin-bottom: 20px;
                cursor: pointer;
            }
            .c{
                width: 300px;
                height: 135px;
                cursor: pointer;
            }
        }
    }
}
</style>